import NiceModal, { useModal } from '@ebay/nice-modal-react'

import Loading from './loading'

type LoadingModalProps = {
  solidBg?: boolean
}

const LoadingModal = ({ solidBg }: LoadingModalProps) => {
  const modal = useModal()

  if (!modal.visible) return null

  return <Loading solidBg={solidBg} />
}

export default NiceModal.create(LoadingModal)
